var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.474 23.71l-6.415-4.387-.135.009-6.399 4.378c-.649.444-1.386.346-1.77-.163-.175-.23-.346-.63-.174-1.235l1.936-6.845a.523.523 0 00-.079-.3l-4.983-5.07c-.416-.422-.558-.964-.38-1.448.177-.484.635-.806 1.225-.86l6.597-.616a.518.518 0 00.234-.175l2.65-6.11C11.02.334 11.476 0 11.998 0c.523 0 .98.334 1.22.893l2.651 6.112a.513.513 0 00.238.169l6.592.614c.592.056 1.048.379 1.225.863.176.484.033 1.024-.382 1.446l-4.986 5.073a.52.52 0 00-.075.298l1.935 6.844c.172.605.001 1.006-.173 1.235a1.144 1.144 0 01-.92.453c-.283 0-.569-.097-.85-.29z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconStarFilled;